module.exports = __webpack_public_path__ + "img/paypal-logo.05d04680.png";